// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"bed204db","800":"9f7516c2","910":"f7b8d34c"}[chunkId] + ".chunk.js";
};